import { Div, CollectionView, TableBuilder, Line, Link, Collection, Span } from "@tblabs/truffle";
import { Order } from "../../../Models/Order";
import { TimeUtils } from "../../../Utils/TimeUtils";
import { DiscountsList } from "../OrderView/Components/DiscountsList";
import { OrdersManager } from "../../../Services/Storage/OrdersManager";
import { OrdersFolders } from "../../../Models/OrdersFolders";
import { Center } from "../../../Components/Utils/Center";


export class OriginsView extends Div
{
    constructor(private orders: CollectionView<Order>)
    {
        super();

        const originsCount: Record<string, number> = {};

        this.orders.Items.forEach(order =>
        {
            const origin = order.People.First()?.Origin?.value?.trim() || "(brak źródła)";

            originsCount[origin] = (originsCount[origin] || 0) + 1;
        });

        const origins = Object.entries(originsCount).map(([origin, count]) => ({ origin, count }));

        this.Append(
            new TableBuilder(origins)
                .AddColumn("Źródło", x => x.origin)
                .AddColumn("Ilość", x => x.count)
                .AddColumn("Procent", x => ((x.count / this.orders.Items.length) * 100).toFixed(0) + "%")
                .Build()
                .Class("uk-table uk-table-small uk-table-divider").MarginAuto().WidthAuto(),

            new Line(),

            new TableBuilder(this.orders)
                .AddColumn("Zamówienie", x => new Link(x.ShortId, `#admin/order/view/${x.Id}`))
                .AddColumn("Utworzone", x => TimeUtils.FormattedDate(x.Meta.CreatedAt))
                .AddColumn("Status", x => x.Status)
                .AddColumn("Zniżki", x => new DiscountsList(x))
                .AddColumn("Źródło", x => x.People.First()?.Origin?.value || "")
                .AddColumn("Profit", x => x.Profit + " zł")
                .Build()
                .WidthAuto().MarginAuto()
        );
    }
}

export class OriginsViewV2 extends Div
{
    constructor(private _manager: OrdersManager)
    {
        super();
    }

    protected async OnAppend(): Promise<void>
    {
        const originsCount: Record<string, number> = {};

        const open: Order[] = await this._manager.FetchAll(OrdersFolders.Open);
        const closed: Order[] = await this._manager.FetchAll(OrdersFolders.Closed);
        const orders = new Collection(open.concat(closed));

        orders.Load(...orders.Filter(x => x.IsDone).sort((a, b) => +b.Meta.CreatedAt - +a.Meta.CreatedAt)
            .filter(x=>{
                const origin = x.People.First()?.Origin?.value || "";
                const isSocialMedia = ["Facebook", "Instagram", "TikTok"].includes(origin);
                const usedDiscounts = x.Meta?.Ticket?.BasketInfo?.Discounts?.map(d => d.Code) || [];
                const hasDiscount = usedDiscounts.some(d => d.startsWith("WK"));
                const force = ["88428", "C7B09"];
                return isSocialMedia || hasDiscount || force.includes(x.ShortId);
    })
        );

        orders.Items.forEach(order =>
        {
            const origin = order.People.First()?.Origin?.value?.trim() || "(brak źródła)";

            originsCount[origin] = (originsCount[origin] || 0) + 1;
        });

        const origins = Object.entries(originsCount).map(([origin, count]) => ({ origin, count }));

        const total = orders.Items.reduce((acc, order) => acc + order.Profit, 0);

        this.Append(
            "\n\nWszystie ukończone zamówienia (otwarte i zamknięte)",
            new TableBuilder(origins)
                .AddColumn("Źródło", x => x.origin)
                .AddColumn("Ilość", x => x.count)
                .AddColumn("Procent", x => ((x.count / orders.Items.length) * 100).toFixed(0) + "%")
                .Build()
                .Class("uk-table uk-table-small uk-table-divider").MarginAuto().WidthAuto(),

            new Line(),

            new TableBuilder(orders)
                .AddColumn("Zamówienie", x => new Link(x.ShortId, `#admin/order/view/${x.Id}`))
                .AddColumn("Utworzone", x => TimeUtils.FormattedDate(x.Meta.CreatedAt))
                // .AddColumn("Status", x => x.Status)
                .AddColumn("Użyte kody", x => x.Meta?.Ticket?.BasketInfo?.Discounts?.map(d => d.Code).join(", ") || "")
                .AddColumn("Źródło", (x, row) =>
                {
                    row.Background(["Facebook", "Instagram", "TikTok"].includes(x.People.First()?.Origin?.value || "") ? "#e6f0fa" : "none");
                    return x.People.First()?.Origin?.value || "";
                })
                .AddColumn("Profit", x => x.Profit + " zł")
                .Build()
                .WidthAuto().MarginAuto(),

            "\n\n",
            new Center(
                new Span(total + " zł").Class("uk-badge").FontSize(20),
                ", 5% = ", new Span(total*0.05 + " zł").Class("uk-badge").FontSize(20),
            ),
            "\n\n",
        );
    }
}
